import React from "react";
import { CardElement } from "@stripe/react-stripe-js";

function SupportCardPayment() {
  return (
    <div>
      <CardElement options={{ hidePostalCode: true }} />
    </div>
  );
}

export default SupportCardPayment;
